<div class="container" style="text-align: center;">
    <p><i class="fa fa-ban" style="color:red; font-size: 65px; margin-top: 60px;"></i></p>
    <h3>Your payment either canceled or rejected</h3>

    <h6 style="color: gray;">Please re-pay your payment</h6>
    <p>
        <a [routerLink]="['/our-products']">Shop more</a>
    </p>
</div>